import { createContext, useContext } from 'react';

/** Everything the CompanyGeneralDataForm sections read: field keys, field states, watched values and handlers. */
const CompanyGeneralDataFormContext = createContext(null);

export const useCompanyGeneralDataForm = () =>
  useContext(CompanyGeneralDataFormContext);

export default CompanyGeneralDataFormContext;
